import React from "react";
import { useSelector } from "react-redux";
import { PaginationControl } from "lib/PaginationControl";
import { push, setParam } from "api/search/filterUrlMaker";
import { isPublicPath } from "lib/routing";

export const AnalystPaginationControl = ({ numHits, pageSize }) => {
  const queryString = useSelector((state) => state.filter.qs);
  if (isPublicPath()) return null;

  const from = queryString.from || 0;
  const onPage = (from) => push(setParam("from", from));

  return <PaginationControl from={from} numHits={numHits} pageSize={pageSize} onPage={onPage} />;
};
